export const ABSMARTLY_EXPERIMENT_BUCKETING_DECISION_EVENT =
  'Absmartly Experiment Bucketing Decision';
